import { WhiteBox } from "@foodpilot/foods";
import { Box, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import type { ReactNode } from "react";
import { useNavigate } from "react-router";

type SettingsCardProps = {
    title: string;
    description?: string;
    icon: ReactNode;
    to: string;
};

export const SETTINGS_CARD_FOODS_ICON_SIZE = 3;
export const SETTINGS_CARD_MUI_ICON_SIZE = 28;

export const SettingsCard = ({ title, description, icon, to }: SettingsCardProps) => {
    const navigate = useNavigate();
    const theme = useTheme();

    return (
        <WhiteBox
            component="button"
            boxShadow="none"
            borderRadius={theme.spacing(1)}
            onClick={() => navigate(to)}
            sx={{
                p: theme.spacing(3.5),
                minHeight: theme.spacing(18),
                cursor: "pointer",
                backgroundColor: theme.custom.grey[100],
                fontFamily: "inherit",
                textAlign: "left",
                transition: "border-color 0.2s ease, box-shadow 0.2s ease",
                "&:hover": {
                    borderColor: theme.custom.grey[1000],
                    boxShadow: "0 8px 24px rgba(57, 58, 54, 0.08)",
                },
            }}
        >
            <Stack direction="row" alignItems="center" spacing={theme.spacing(3)}>
                <Box
                    sx={{
                        width: theme.spacing(6),
                        height: theme.spacing(6),
                        borderRadius: theme.spacing(1),
                        backgroundColor: theme.custom.grey[300],
                        color: theme.palette.primary[600],
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                    }}
                >
                    {icon}
                </Box>
                <Box sx={{ minWidth: 0 }}>
                    <Typography
                        variant="h4"
                        sx={{
                            color: theme.custom.grey[2800],
                            mb: description ? theme.spacing(1) : 0,
                        }}
                    >
                        {title}
                    </Typography>
                    {description ?
                        <Typography variant="body" sx={{ color: theme.custom.grey[2100] }}>
                            {description}
                        </Typography>
                    :   null}
                </Box>
            </Stack>
        </WhiteBox>
    );
};
